export const defaultOnComplete = () => Promise.resolve();

export const defaultOnNext = () => Promise.resolve();

export const defaultOnUploadFiles = () => Promise.resolve();
